import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ErrorLabel from "../../../../component/error_label";
import { useNavigate } from "react-router-dom";
import { useDispatch,useSelector } from "react-redux";
import { actionAdminLogin, resetAdminLoginResponse } from "../store";
import { TOAST_DURATION, TOAST_POSITION, TOAST_SUCCESS_COLOR } from "../../../../common/app_constant";
import toast from "react-hot-toast";
import { jwtDecode } from "jwt-decode";
import { getNextScreen } from "../../../../utils";

const LoginAdmin = () => {

let navigate = useNavigate()
const { AdminLogin } = useSelector((state) => ({
    ...state.publicStore
}))
const dispatch = useDispatch()

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      code: "axis",
      email: "",
      password: "",
    },
  });

const onSubmit = async (data) => {
    dispatch(actionAdminLogin(data))
}

useEffect(() => {
  if (AdminLogin !== null) {
  dispatch(resetAdminLoginResponse())
  if (AdminLogin && AdminLogin.status){
      const decoded = jwtDecode(AdminLogin?.data?.token);
      getNextScreen(decoded?.role)
      localStorage.setItem("userData", JSON.stringify(AdminLogin.data.userData));
      localStorage.setItem("token", JSON.stringify(AdminLogin.data.token));
      navigate("/employer/dashboard")
  } else {
    toast.error(AdminLogin?.message, {
      duration: TOAST_DURATION,
      position: TOAST_POSITION,
      style: {
        color: TOAST_SUCCESS_COLOR,
      },
    });
  }
}
},[AdminLogin])

  return (
    <>
    <div className="container mt-6">
        <div className="row justify-content-center py-5">
          <div className="col-4">
            <div className="container border py-3">
              <form onSubmit={handleSubmit(onSubmit)}>
                  <h5>Admin Login</h5>
                <div class="form-group mt-2">
                  <label className="form-label" htmlFor="email">
                    Email ID
                  </label>
                  <input
                    type="text"
                    id="email"
                    name="email"
                    className="form-control form-control-lg"
                    placeholder="Enter a valid email id"
                    {...register("email", {
                      required: "This is required.",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "invalid email address",
                      },
                    })}
                  />
                  
                  {errors.email && <ErrorLabel message={errors.email?.message} />}
                </div>
                <div class="form-group mt-3">
                  <label for="exampleInputPassword1">Password</label>
                  <input
                      className="form-control form-control-lg"
                      type="password"
                      id="password"
                      name="password"
                      placeholder="Password"
                      {...register(
                          "password",
                          {
                              required: "This is required.",
                          }
                      )}
                  />
                  {errors.password && <ErrorLabel message={errors.password?.message} />}
                </div>
              
                <button type="submit" class="btn btn-primary mt-3">
                  Submit
                </button>
              </form>
            </div>
            <div className="text-center mt-2">
            <a href="/admin-forgot-password">Forgot Passowrd</a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default LoginAdmin;
